module.exports = __webpack_public_path__ + "static/img/bilibili.8cdceef7.png";